import { NgModule } from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../shared/shared.module';
import { SecurityRoutingModule } from './security-routing.module';

import {ModuleComponent} from './components/module/module.component';
import {ModuleAddEditComponent} from './components/module/module-add-edit/module-add-edit.component';
import {MenuComponent} from './components/menu/menu.component';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {NgSelectModule} from '@ng-select/ng-select';
import {PermissionComponent} from './components/permission/permission.component';
import {UserComponent} from './components/user/user.component';
import {UserEditComponent} from './components/user/user-edit/user-edit.component';
import {UserAddComponent} from './components/user/user-add/user-add.component';
import {RoleComponent} from './components/role/role.component';
import {RoleAddComponent} from './components/role/role-add/role-add.component';
import {TreeviewModule} from '@charmedme/ngx-treeview';
import {MenuEditComponent} from './components/menu/menu-edit/menu-edit.component';
import {UserPasswordUpdateComponent} from './components/user/user-password-update/user-password-update.component';
import {RoleEditComponent} from './components/role/role-edit/role-edit.component';
import {InstitutionComponent} from './components/institution/institution.component';
import {InstitutionAddComponent} from './components/institution/institution-add/institution-add.component';
import {InstitutionEditComponent} from './components/institution/institution-edit/institution-edit.component';
import {BranchComponent} from './components/branch/branch.component';
import {BranchAddComponent} from './components/branch/branch-add/branch-add.component';
import {BranchEditComponent} from './components/branch/branch-edit/branch-edit.component';
import {UserChangePasswordComponent} from './components/user/user-change-password/user-change-password.component';
import {UserProfileComponent} from './components/user/user-profile/user-profile.component';
import {UserInstitutionUpdateComponent} from './components/institution/user-institution-update/user-institution-update.component';
import {YearComponent} from './components/year/year.component';
import {YearAddEditComponent} from './components/year/year-add-edit/year-add-edit.component';
import {CurrentYearComponent} from './components/current-year/current-year.component';
import {PermissionAddEditComponent} from './components/permission/permission-add-edit/permission-add-edit.component';
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {from, Observable} from 'rxjs';
import {MenuAddComponent} from "./components/menu/menu-add/menu-add.component";
import {SubmenuAddComponent} from "./components/submenu/submenu-add/submenu-add.component";
import {SingleEditComponent} from "./components/single/single-edit/single-edit.component";
import {SubmenuEditComponent} from "./components/submenu/submenu-edit/submenu-edit.component";
import {SingleAddComponent} from "./components/single/single-add/single-add.component";
import {SubmenuComponent} from "./components/submenu/submenu.component";
import {SingleComponent} from "./components/single/single.component";
import {LabelComponent} from "./components/label/label.component";
import {LabelAddEditComponent} from "./components/label/label-add-edit/label-add-edit.component";
import {UserBranchesUpdateComponent} from "./components/user/user-branches-update/user-branches-update.component";
import {SystemSettingsComponent} from "./components/system-settings/system-settings.component";
import {SystemLicenseComponent} from "./components/system-license/system-license.component";
import {SystemLicenseAddEditComponent} from "./components/system-license/system-license-add-edit/system-license-add-edit.component";
import {LicenseBannerComponent} from "./components/license/license-banner.component";
import {CustomerLicenseComponent} from "./components/customer-license/customer-license.component";
import {MatCardModule} from "@angular/material/card";
import {
  AccountingSystemSettingsComponent
} from "./components/accounting-system-settings/accounting-system-settings.component";
export class LazyTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<any> {
    return from(import(`../../../assets/i18n/${lang}.json`));
  }
}
@NgModule({
  declarations: [
    ModuleComponent,
    ModuleAddEditComponent,

    LabelComponent,
    LabelAddEditComponent,

    SingleComponent,
    SingleAddComponent,
    SingleEditComponent,

    MenuComponent,
    MenuAddComponent,
    MenuEditComponent,

    SubmenuComponent,
    SubmenuAddComponent,
    SubmenuEditComponent,

    PermissionComponent,
    PermissionAddEditComponent,

    InstitutionComponent,
    InstitutionAddComponent,
    InstitutionEditComponent,
    BranchComponent,
    BranchAddComponent,
    BranchEditComponent,

    UserComponent,
    UserAddComponent,
    UserEditComponent,
    UserPasswordUpdateComponent,
    RoleComponent,
    RoleAddComponent,
    RoleEditComponent,

    YearComponent,
    YearAddEditComponent,
    CurrentYearComponent,

    UserChangePasswordComponent,
    UserProfileComponent,
    UserInstitutionUpdateComponent,

    UserBranchesUpdateComponent,
    SystemSettingsComponent,
	SystemLicenseComponent,
	SystemLicenseAddEditComponent,
    CustomerLicenseComponent,
    LicenseBannerComponent,
    //Accounting
    AccountingSystemSettingsComponent
  ],
  imports: [
    CommonModule,
    SecurityRoutingModule,
    NgbModule,
    SharedModule,
    NgxDatatableModule,
    NgSelectModule,
    TreeviewModule,
    TranslateModule.forChild({
      extend: true
      //defaultLanguage: 'fr',
      //isolate: true,
      //loader: {provide: TranslateLoader, useClass: LazyTranslateLoader}
    }),
    MatCardModule
  ],
  exports: [
    LicenseBannerComponent
  ],
  providers: [
    DatePipe,
    NgbActiveModal
  ]
})
export class SecurityModule { }
